export default __webpack_public_path__ + "static/media/no_schedule.eea8ccae.png";